import React, { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import data from '../data/services.json';

const AppleSection = ({ title, children }) => (
  <section style={{ padding: '32px 0' }}>
    {title && (
      <h2 style={{ fontSize: 'clamp(28px, 3.6vw, 40px)', fontWeight: 600, letterSpacing: '-0.01em', lineHeight: 1.1, marginBottom: 12 }}>
        {title}
      </h2>
    )}
    {children}
  </section>
);

const Badge = ({ children }) => (
  <span style={{ fontSize: 13, padding: '6px 10px', borderRadius: 999, background: 'rgba(0,0,0,0.05)' }}>{children}</span>
);

const ServiceDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const service = useMemo(() => data[slug], [slug]);

  if (!service) {
    return (
      <div style={{ maxWidth: 980, margin: '0 auto', padding: '56px 20px 80px 20px' }}>
        <p>Bu hizmet bulunamadı.</p>
      </div>
    );
  }

  return (
    <div style={{ background: '#fff' }}>
      <div style={{ padding: '56px 20px 24px 20px' }}>
        <div style={{ maxWidth: 980, margin: '0 auto' }}>
          <button onClick={() => navigate('/hizmetler')} style={{ color: '#06c', fontSize: 14, marginBottom: 16, background: 'transparent', border: 0, cursor: 'pointer' }}>
            ← Tüm hizmetler
          </button>
          <h1 style={{ fontSize: 'clamp(36px, 5vw, 56px)', fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.05, marginBottom: 8 }}>{service.title}</h1>
          <p style={{ color: '#6e6e73', fontSize: 18, maxWidth: 700 }}>{service.subtitle}</p>
        </div>
      </div>

      <div style={{ position: 'relative' }}>
        <div style={{ maxWidth: 1120, margin: '0 auto' }}>
          <div style={{
            height: 320,
            backgroundImage: `url("${service.heroImage}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: 20,
            margin: '0 20px'
          }} />
        </div>
      </div>

      <div style={{ maxWidth: 980, margin: '0 auto', padding: '24px 20px 80px 20px' }}>
        <AppleSection title="Özet">
          <p style={{ color: '#6e6e73', fontSize: 17, lineHeight: 1.6 }}>{service.summary}</p>
        </AppleSection>

        <AppleSection title="Öne çıkanlar">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
            {service.highlights.map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', border: '1px solid rgba(0,0,0,0.06)', borderRadius: 12 }}>
                <span style={{ width: 6, height: 6, borderRadius: 999, background: 'currentColor', color: '#06c' }} />
                <span style={{ fontSize: 15 }}>{item}</span>
              </div>
            ))}
          </div>
        </AppleSection>

        <AppleSection title="Süreç">
          <ol style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16, counterReset: 'step' }}>
            {service.process.map((step, i) => (
              <li key={i} style={{ border: '1px solid rgba(0,0,0,0.06)', borderRadius: 16, padding: 16 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                  <Badge>{i + 1}</Badge>
                  <strong>{step.title}</strong>
                </div>
                <p style={{ color: '#6e6e73', fontSize: 15, lineHeight: 1.5 }}>{step.desc}</p>
              </li>
            ))}
          </ol>
        </AppleSection>

        <AppleSection title="Bilgilendirme">
          <p style={{ color: '#6e6e73', fontSize: 16, lineHeight: 1.6 }}>
            Ücretler cihazın durumu ve taleplere göre mağazamızda yapılan ön inceleme ve teknik analiz sırasında belirlenir. Bu sayfa bilgilendirme amaçlıdır.
          </p>
        </AppleSection>

        <AppleSection title="Sıkça sorulanlar">
          <div style={{ display: 'grid', gap: 12 }}>
            {service.faq.map((f, i) => (
              <details key={i} style={{ border: '1px solid rgba(0,0,0,0.06)', borderRadius: 12, padding: '12px 14px' }}>
                <summary style={{ cursor: 'pointer', fontWeight: 600 }}>{f.q}</summary>
                <p style={{ color: '#6e6e73', marginTop: 8 }}>{f.a}</p>
              </details>
            ))}
          </div>
        </AppleSection>

        
      </div>
    </div>
  );
};

export default ServiceDetail;
